import { createSlice } from "@reduxjs/toolkit";
import {
  registerMerchant,
  verifyOtpMerchant,
  resendOtpMerchant,
  loginMerchant,
  getMerchantProfile,
  logoutMerchant,
  restoreSession,
} from "./merchantThunks";

const initialState = {
  loading: false,
  error: null,
  user: null,
  accessToken: null,  
  registrationSuccess: false,
  otpVerified: false,
   isLoggedOut: false,
};
      
const merchantSlice = createSlice({
  name: "merchant",
  initialState,
  reducers: {
    setAuthTokens: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.user = action.payload.user || state.user;
    },
  },

  extraReducers: (builder) => {
    builder
      // REGISTER
      .addCase(registerMerchant.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.registrationSuccess = false;
      })
      .addCase(registerMerchant.fulfilled, (state) => {
        state.loading = false;
        state.registrationSuccess = true;
      })
      .addCase(registerMerchant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Registration failed";
      })

      // OTP VERIFY
      .addCase(verifyOtpMerchant.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.otpVerified = false;
      })
      .addCase(verifyOtpMerchant.fulfilled, (state, action) => {
        state.loading = false;
        state.otpVerified = true;
      })
      .addCase(verifyOtpMerchant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "OTP verification failed";
      })

      // RESEND OTP
      .addCase(resendOtpMerchant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resendOtpMerchant.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(resendOtpMerchant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to resend OTP";
      })

      // LOGIN
      .addCase(loginMerchant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginMerchant.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.accessToken = action.payload.accessToken;
      })
      .addCase(loginMerchant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Login failed";
        state.user = null;
        state.accessToken = null;
      })

      // PROFILE
      .addCase(getMerchantProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMerchantProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(getMerchantProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to load profile";
      })

      // LOGOUT
         .addCase(logoutMerchant.fulfilled, (state) => {
             return initialState; // 🔥 FULL RESET
             })
        .addCase(logoutMerchant.rejected, (state) => {
        return initialState;
        })
// merchant restore by reload the browser 
    builder
  .addCase(restoreSession.pending, (state) => {
    state.loading = true;
  })
 .addCase(restoreSession.fulfilled, (state, action) => {
  if (state.isLoggedOut) {
    state.loading = false;
    return;
  }

  state.loading = false;
  state.user = action.payload.user;
  state.accessToken = action.payload.accessToken;
})

  .addCase(restoreSession.rejected, (state) => {
  state.loading = false;
  state.user = null;
  state.accessToken = null;
});
  },
});

export const { setAuthTokens } = merchantSlice.actions;
export default merchantSlice.reducer;
